<template>
  <div class="about">
    <div class="title">热销产品</div>
    <div class="links">
      <a class="link" :href="'nzscxq.html?id=' + item.proId+'&proSort='+item.proSort+'&categoryId='+item.categoryId" :title="item.proName" v-for="item in list" :key="item.proId" >
        <el-image
          lazy
          :src="item.websiteImg"
          fit="cover"
        >
          <div slot="placeholder" class="image-slot">
            <img
              src="data:image/png;base64,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"
            />
          </div>
        </el-image><div class="proName">{{item.proName}}</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list"],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.about {
  width: 100%;
  border: 1px solid #e6e6e6;
  background: #f5f5f5;
  padding: 22px 22px 0 22px;
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    padding: 15px 0 0;
    margin-bottom: 15px;
  }
  .links {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .link {
      width: 174px;
      border: 1px solid transparent;
      margin-right: 16px;
      margin-bottom: 22px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      position: relative;
      flex-shrink: 0;
      &:hover{
          border-color: #65B825;
      }
      .proName{
        // position: absolute;
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding: 0 15px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color:#333;
        font-size: 16px;
        text-align: center;
      }
      .el-image {
        width: 173px;
        height: 173px;
      }
    }
  }
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}
a{
  text-decoration: none;
}
@media screen and (max-width: 1200px) {
  .about .links{
    overflow: scroll;
  }
}
</style>
